import { createAction } from '@reduxjs/toolkit';

import type { IActionType } from './media.types';

export const setMedia = createAction<IActionType>('media/set');
